import React from 'react'
import { connect } from 'react-redux'
import styles from './style'
import injectSheet from 'react-jss'
import DowntiltInput from './DowntiltInput'
import DowntiltDisplay from './DowntiltDisplay'
import DistanceToBlindSpotDisplay from './DistanceToBlindSpotDisplay'
import CameraHeightLabel from './CameraHeightLabel'
import SceneHeightLabel from './SceneHeightLabel'
import BlindSpotCheckbox from './BlindSpotCheckbox'
import { updateCalculatorAction } from 'actions/calculatorActions'
import { updateFixedLensAction, updateAllLensesAction } from 'actions/multiImagerActions'
import { updateUiAction } from 'actions/uiActions'
import { cameraPropSelector, uiPropSelector, presentationPropSelector,
  friendlyTiltSelector, friendlyTiltPresentationSelector, userSettingsPropSelector } from 'selectors/components'
import { computedHeightBoundSelector, cameraHeightGreaterThanComputedSelector,
  distanceDisplaySelector, unitSelector, angleSelector, cameraPxHeightSelector,
  sceneHeightLabelPxHeightSelector, otherAngleSelector, resolutionSelector, convertedDistanceSelector, isImperialSelector } from './selectors'

const mapStateToProps = state => ({
  presentationCameraHeight: presentationPropSelector('cameraHeight')(state),
  presentationSceneHeight: presentationPropSelector('sceneHeight')(state),
  presentationTilt: friendlyTiltPresentationSelector(state),
  showCameraBlindspot: uiPropSelector('showCameraBlindspot')(state),
  showAnalyticZones: uiPropSelector('showAnalyticZones')(state),
  horizontalAngleOfView: cameraPropSelector('horizontalAngleOfView')(state),
  color: cameraPropSelector('color')(state),
  tilt: cameraPropSelector('tilt')(state),
  friendlyTilt: friendlyTiltSelector(state),
  distance: cameraPropSelector('distance')(state),
  id: cameraPropSelector('id')(state),
  computedHeightBound: computedHeightBoundSelector(state),
  cameraHeightGreaterThanComputed: cameraHeightGreaterThanComputedSelector(state),
  distanceDisplay: distanceDisplaySelector(state),
  unit: unitSelector(state),
  angle: angleSelector(state),
  otherAngle: otherAngleSelector(state),
  resolution: resolutionSelector(state),
  convertedDistance: convertedDistanceSelector(state),
  cameraPxHeight: cameraPxHeightSelector(state),
  sceneHeightLabelPxHeight: sceneHeightLabelPxHeightSelector(state),
  isFixedImager: cameraPropSelector('isFixedImager')(state),
  imagerId: cameraPropSelector('imagerId')(state),
  rawCameraHeight: cameraPropSelector('cameraHeight')(state),
  rawSceneHeight: cameraPropSelector('sceneHeight')(state),
  isImperial: isImperialSelector(state),
  ppfZoneBorders: userSettingsPropSelector('ppfZoneBorders')(state),
  ppfZoneColorOverride: userSettingsPropSelector('ppfZoneColorOverride')(state),
  ppfZoneColors: userSettingsPropSelector('ppfZoneColors')(state)
})

class DowntiltDisplayContainer extends React.Component {
  render() {
    const {
      presentationCameraHeight, presentationSceneHeight, presentationTilt,
      showCameraBlindspot, cameraHeightGreaterThanComputed, isFixedImager,
      distanceDisplay, unit, angle, cameraPxHeight, sceneHeightLabelPxHeight,
      horizontalAngleOfView, tilt, friendlyTilt, distance, id, isImperial, classes,
      updateCalculatorAction, updateFixedLensAction, updateAllLensesAction, updateUiAction, rawCameraHeight,
      rawSceneHeight, otherAngle, resolution, convertedDistance, showAnalyticZones, color, imagerId,
      ppfZoneBorders, ppfZoneColorOverride
    } = this.props
    const callback = isFixedImager ? updateFixedLensAction : updateCalculatorAction
    const cameraHeightCallback = imagerId ? updateAllLensesAction : updateCalculatorAction
    const ppfZoneColors = ppfZoneColorOverride ? this.props.ppfZoneColors : [color, color, color, color]

    return (
      <div className={horizontalAngleOfView >= 180 ? classes.blurred : ''}>
        <BlindSpotCheckbox {...{ showCameraBlindspot, updateUiAction }} />
        <DistanceToBlindSpotDisplay />
        <div>
          <div className={classes.displayContainer}>
            <DowntiltDisplay {...{ angle, tilt, cameraPxHeight, distance: convertedDistance, otherAngle, resolution, showAnalyticZones, color, ppfZoneBorders, ppfZoneColors }} />
            <CameraHeightLabel {...{ cameraPxHeight, angle, unit, color }} />
            <div className={classes.overflowContainer}>
              <SceneHeightLabel
                {...{ distanceDisplay, sceneHeightLabelPxHeight,
                  cameraHeightGreaterThanComputed, unit }}
              />
            </div>
            <span
              className={classes.distanceDisplay}
              style={{ display: distance >= distanceDisplay ? 'none' : 'initial' }}
            >
              {`${distanceDisplay}${unit}`}
            </span>
          </div>
          <div className={classes.inputContainer}>
            <DowntiltInput
              cameraId={id}
              label={'Camera Height'}
              value={presentationCameraHeight}
              fnKey={'cameraHeight'}
              unit={isImperial ? 'ft' : 'm'}
              callback={cameraHeightCallback}
              rawValue={rawCameraHeight}
            />
            <DowntiltInput
              cameraId={id}
              label={'Tilt'}
              value={presentationTilt}
              fnKey={'tilt'}
              unit='°'
              isImperial={isImperial}
              callback={callback}
              rawValue={friendlyTilt}
            />
            <DowntiltInput
              cameraId={id}
              label={'Scene Height'}
              value={presentationSceneHeight}
              fnKey={'sceneHeight'}
              unit={isImperial ? 'ft' : 'm'}
              callback={callback}
              rawValue={rawSceneHeight}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default injectSheet(styles)(
  connect(mapStateToProps, { updateCalculatorAction, updateFixedLensAction, updateAllLensesAction, updateUiAction })(DowntiltDisplayContainer)
)



// WEBPACK FOOTER //
// ./src/components/BlindSpotPanelContainer/DowntiltDisplayContainer/index.js